import {
  inventoryItemIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";

/**
 * Resolve the merchant team id that owns each transfer line. Guided transfer
 * scanning uses the map to attribute a line to a specific merchant and evaluate
 * per-merchant policies like the strict license-plate bypass list — the same
 * role getFulfillmentGroupMerchantTeamIds plays for pick sessions.
 *
 * Lines are keyed by product id (aggregate lines) or inventory item id
 * (license-plated unit lines); callers pass whichever ids apply. Any id outside
 * the caller's own account or its managed merchants resolves to `null`.
 */
export const getTransferLineMerchantTeamIds = {
  name: "getTransferLineMerchantTeamIds" as const,
  input: z.object({
    productIds: z
      .array(productIdFormat.schema)
      .max(1000)
      .optional()
      .default([]),
    inventoryItemIds: z
      .array(inventoryItemIdFormat.schema)
      .max(1000)
      .optional()
      .default([]),
  }),
  output: z.object({
    merchantTeamIdByProductId: z.record(
      productIdFormat.schema,
      z.string().nullable(),
    ),
    merchantTeamIdByInventoryItemId: z.record(
      inventoryItemIdFormat.schema,
      z.string().nullable(),
    ),
  }),
};
